import type { MappingBreakdownResponse, TopItem } from '@/entities/dashboard';

export const BREAKDOWN_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'];

export function formatPieChartData(
  breakdownData: MappingBreakdownResponse | undefined,
  colors: string[] = BREAKDOWN_COLORS
): Array<{ name: string; value: number; color: string }> {
  if (!breakdownData?.breakdown?.series) return [];

  // `value` is the tonnage and `percentage` its share — plotting the share made the
  // slices right but every number wrong, since the popup reports them as MT.
  return breakdownData.breakdown.series.slice(0, 5).map((item: TopItem, index: number) => ({
    name: item.name,
    value: item.value,
    color: item.color || colors[index % colors.length]
  }));
}
